import React from "react";

import { ReactComponent as HushBorderMobileSVG } from "src/images/svg/hush-border-mobile.svg";

import "./hush-border-mobile.css";

export const HushBorderMobile = ({ className }: { className?: string }) => {
	return <HushBorderMobileSVG className={className} />;
};
